import React from 'react';
import './Dashboard.css';
// import Navbar from './navbar';
import About from './about';
import Project from './projects';
import Count from './count';
import Testimonial from './testimonial';
import Organisation from './organisation';

const Dashboard = () => (
    <div className='Dashboard-container'>
        {/* <Navbar /> */}
        <About />
        <Project />
        <Count />
        <Testimonial />
        <Organisation />
    </div>
);

export default Dashboard;